import React, { useState } from "react";
import { useInventarioInicial } from "../../../contexto/provider/InventarioInicialContext.js";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import TablaInventarioInicial from "../../inventario/inventarioInicial/tabla/TablaInventarioInicial.js";
import InventarioInicialForm from "../inventarioInicial/form/formInventarioInicial.js";

import "./modulo.css";


export default function EjecutarInventarioInicial() {

  const { crearInventario } = useInventarioInicial();

  const [periodoId, setPeriodoId] = useState(null);
  const [tipoInventario, setTipoInventario] = useState(1);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const handleClickCrearInventario = async () => {

    if (!periodoId) {
      setMensaje("Debes seleccionar un periodo");
      return;
    }

    setLoading(true);

    try {

      const result = await crearInventario(periodoId);

      if (result.success) {
        setMensaje("Inventario inicial creado correctamente.");
      } else {
        setMensaje(result.error);
      }

    } catch (error) {

      setMensaje("Error inesperado al crear el inventario");

    }

    setLoading(false);
  };

  return (

    <div className="contenedor-tabla">

      <TituloModulo titulo="Inventario Inicial" />

      <InventarioInicialForm
        periodoId={periodoId}
        setPeriodoId={setPeriodoId}
        tipoInventario={tipoInventario}
        setTipoInventario={setTipoInventario}
        loading={loading}
        mensaje={mensaje}
        onCrearInventario={handleClickCrearInventario}
        onActualizarInventario={() => setMostrarTabla(true)}
      />

      {mostrarTabla && (
        <TablaInventarioInicial periodoId={periodoId} />
      )}

    </div>

  );
}